import { ExpressionSpecification } from 'maplibre-gl'

export const createPaintExpression = (
  metricName: string,
  paintExpression: ExpressionSpecification,
): ExpressionSpecification => {
  return [
    'case',
    ['has', metricName],
    paintExpression,
    '#b3b3b3', // if state is missing gray!
  ]
}

export const getSpeedProfileMetricPaint = (metricName: string): ExpressionSpecification => {
  return [
    'interpolate',
    ['linear'],
    ['get', metricName],
    0,
    '#fffde7',
    20,
    '#fff9c4',
    40,
    '#fff176',
    60,
    '#ffee58',
    90,
    '#fdd835',
    120,
    '#f9a825',
  ]
}
